var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-tab"},_vm._l((_vm.tabs),function(item){return _c('div',{key:item.value,class:['tab', _vm.value === item.value ? 'active' : 'inactive'],style:(_vm.theme && _vm.value === item.value
        ? {
            color: _vm.theme.activeTextColor
          }
        : {}),on:{"click":function($event){return _vm.handleClick(item.value)}}},[_vm._v(" "+_vm._s(item.label)+" "),_c('i',{style:(_vm.theme
          ? {
              backgroundColor: _vm.theme.activeTextColor
            }
          : {})})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }